import { Modal, styled } from '@mui/material';

export const Embla = styled('div')(({ theme }) => ({
  maxWidth: '80rem',
  paddingInline: '0.5rem',
  margin: 'auto',
  '--slide-height': '32rem',
  '--slide-spacing': '1rem',
  '--slide-size': '55%',

  [theme.breakpoints.down('lg')]: {
    '--slide-size': '80%',
  },
  [theme.breakpoints.down('md')]: {
    '--slide-size': '100%',
    '--slide-height': '24rem',
    '--slide-spacing': '0',
    paddingInline: '0.2rem',
  },
}));

export const EmblaViewport = styled('div')(({ theme }) => ({
  position: 'relative',

  overflow: 'hidden',
  marginInline: '4rem',
  [theme.breakpoints.down('md')]: {
    marginInline: '1rem',
  },
  ':after': {
    boxShadow: `inset 15px 0px 10px -7px ${theme.palette.background.default}, inset -15px 0px 10px -7px ${theme.palette.background.default}`,
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));

export const EmblaContainer = styled('div')({
  display: 'flex',
  touchAction: 'pan-y pinch-zoom',
  marginLeft: 'calc(var(--slide-spacing) * -1)',
});

export const EmblaSlide = styled('div')({
  transform: 'translate3d(0, 0, 0)',
  flex: '0 0 var(--slide-size)',
  minWidth: 0,
  paddingLeft: 'var(--slide-spacing)',
  backfaceVisibility: 'hidden',
});
export const EmblaSlideImg = styled('img')(({ theme }) => ({
  borderRadius: '1rem',
  display: 'block',
  height: 'calc(var(--slide-height) * 0.95)',
  margin: 'calc(var(--slide-height) * 0.025)',
  objectFit: 'contain',
  aspectRatio: '1/1',
  width: '100%',
  cursor: 'pointer',
  '&:hover': {
    filter: 'drop-shadow(0 0 0.35rem #5c608a)',
  },
  [theme.breakpoints.down('md')]: {
    width: 'calc(100% - 20px)',
    margin: '10px',
    '&:hover': {
      filter: 'drop-shadow(0 0 0.35rem #5c608a)',
    },
  },
}));

export const EmblaControls = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  justifyContent: 'space-between',
  gap: '1.2rem',
  marginTop: '1.8rem',
});

export const EmblaButton = styled('button')(({ theme }) => ({
  WebkitTapHighlightColor: 'rgba(var(--text-high-contrast-rgb-value), 0.5)',
  WebkitAppearance: 'none',
  appearance: 'none',
  backgroundColor: 'transparent',
  touchAction: 'manipulation',
  display: 'inline-flex',
  textDecoration: 'none',
  cursor: 'pointer',
  border: 0,
  padding: 0,
  margin: 0,
  boxShadow: 'inset 0 0 0 0.2rem var(--detail-medium-contrast)',
  width: '3rem',
  zIndex: 1,
  borderRadius: '50%',
  color: `${theme.palette.blueColors?.PLUS_3}`,
  alignItems: 'center',
  justifyContent: 'center',
  '&:disabled': {
    color: `${theme.palette.greyColors?.MINUS_1}`,
  },
  [theme.breakpoints.down('md')]: {
    width: '4rem',
  },
}));

export const EmblaButtonSvg = styled('svg')({
  width: '25%',
  height: '25%',
});

export const EmblaWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const StyledModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledSVG = styled('svg')({
  transition: 'fill 0.3s ease, filter 0.3s ease',
  fill: 'currentColor',
  // filter: 'drop-shadow(0 0 0.3rem #404eed)',

  '&:hover': {
    filter: 'drop-shadow(0 0 0.5rem #404eed)',
  },
});

export const StyledImgWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  outline: 'none',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    maxHeight: '90%',
    maxWidth: '98%',
  },
}));

export const StyledImg = styled('img')<{
  cursorX?: number;
  cursorY?: number;
  isZoomed: boolean;
}>(({ theme, cursorX, cursorY, isZoomed }) => ({
  maxHeight: '80%',
  maxWidth: '80%',
  outline: 'none',
  borderRadius: '0.8rem',
  transition: 'transform 0.1s ease-out',
  transformOrigin: `${cursorX || 50}% ${cursorY || 50}%`,
  transform: 'scale(1)',
  cursor: isZoomed ? 'zoom-out' : 'zoom-in',
  [theme.breakpoints.down('md')]: {
    maxHeight: '90%',
    maxWidth: '98%',
  },
}));
